import React from 'react';
import '../less/TextAboveFooter.less';

export default function template() {
  const { widget } = this.props;

  return (
    widget && widget.data && widget.data[0] && widget.data[0].desc_ua && widget.data[0].desc_ua.length > 0 ? (
      <div className="compliance">
        <div className="container">
          <div className="compliance__body" dangerouslySetInnerHTML={{__html: widget.data[0].desc_ua}}></div>
        </div>
      </div>
    ) : ''
  );
}
